import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(
  (theme) => ({
    restaurantSelectorOuterContainer: {
      position: 'relative',

      '& input:focus': {
        outlineStyle: 'none',
        boxShadow: '0 0 0 1px #000000',
      },
    },
    restaurantSelectorContainer: {
      position: 'relative',
    },
    restaurantSelector: {
      border: 'solid 1px #aeaeae',
      borderRadius: '6px',
      cursor: 'text',
      userSelect: 'none',
      backgroundColor: '#ffffff',
      transitionDuration: '0.1s',
      whiteSpace: 'nowrap',
    },
    restaurantSelectorOpen: {
      borderRadius: '6px 6px 0 0',
    },
    restaurantSelectorContent: {
      display: 'flex',
      justifyContent: 'space-between',

      '& > *:last-child': {
        marginRight: '15px',
        marginTop: '15px',
        position: 'absolute',
        right: '0',
      },

      '& > .text-field-inner': {
        flexGrow: 1,
      },
    },
    textFieldInput: {
      borderRadius: '6px',
      padding: '15px 20px',
      border: 'none',
      width: '100%',
      maxWidth: '100%',
      fontSize: '16px',
      // fontFamily: Gordita, 'Helvetica', 'sans-serif';
    },
    menu: {
      position: 'absolute',
      top: '48px',
      backgroundColor: '#fff',
      left: '0',
      right: '0',
      border: 'solid 1px #aeaeae',
      borderRadius: '0 0 6px 6px',
      boxShadow: '0 4px 14px 0 rgba(202, 202, 202, 0.5)',
      transitionDuration: '0.05s',
      zIndex: '20',
      overscrollBehavior: 'contain',

      '& > *:last-child': {
        paddingBottom: '10px',
        borderRadius: '0 0 6px 6px',
      },
    },
    divider: {
      color: '#dcdcdb',
      marginLeft: '5px',
      marginRight: '5px',
    },
    menuItem: {
      padding: '16px 20px',
      cursor: 'pointer',
      userSelect: 'none',
      backgroundColor: '#ffffff',
      display: 'flex',
      justifyContent: 'space-between',
    },
    menuItemHovered: {
      filter: 'brightness(95%)',
    },
    status: {
      color: '#313131',
      backgroundColor: '#dcdcdb',
      borderRadius: '4px',
      padding: '5px 10px',
      maxHeight: '24px',
    },
    spacer: {
      height: '1px',
      backgroundColor: '#dcdcdb',
    },
    spacerMargin: {
      marginLeft: '16px',
      marginRight: '16px',
    },
    endAdornment: {
      display: 'flex',
    },
    dropdownHidden: {
      pointerEvents: 'none',
      opacity: '0',
    },
    dropdownVisible: {
      opacity: '1',
    },
  }),
  { name: 'RestaurantSelector' },
);

export default useStyles;
